import React, { FC, useState } from 'react'
import { useIntl } from 'react-intl'
import InputLabel from '@material-ui/core/InputLabel'
import Grid from '@material-ui/core/Grid'
import MenuItem from '@material-ui/core/MenuItem'
import Switch from '@material-ui/core/Switch'
import Slider from '@material-ui/core/Slider'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Select from '@material-ui/core/Select'

import { headerHeight, leftSidebarToolsWidth } from '../../Constants'
import WgAppComponent from '../3d/geonovop0/src/WgAppComponent.jsx'

import { mapView3dStyle } from './MapView3D.style'

export interface MapView3DProps {} // eslint-disable-line @typescript-eslint/no-empty-interface

/**
 * MapView3D React component.
 * @param {object} props React properties object.
 * @returns React view component.
 */
export const MapView3D: FC<MapView3DProps> = (props: MapView3DProps) => {
  const classes = mapView3dStyle()
  const intl = useIntl()

  const menuRef = React.createRef()

  const [geoModelId, setGeoModelId] = useState(702)
  const [heightScale, setHeightScale] = useState(30)
  const [clipAxis, setClipAxis] = useState(0)
  const [clipPolygonEnabled, setClipPolygonEnabled] = useState(false)
  const [buildingsEnabled, setBuildingsEnabled] = useState(true)
  const [boreholesEnabled, setBoreholesEnabled] = useState(true)
  const [mapEnabled, setMapEnabled] = useState(true)

  return (
    <div
      className={classes.root}
      style={{ height: `calc(100vh - ${headerHeight}px)` }}
    >
      <WgAppComponent
        heightScale={heightScale}
        geoModelId={geoModelId}
        buildingsEnabled={buildingsEnabled}
        boreholesEnabled={boreholesEnabled}
        mapEnabled={mapEnabled}
        clipPolygonEnabled={clipPolygonEnabled}
        clipAxis={clipAxis}
      />
      <AppBar
        className={classes.appBar}
        style={{ left: leftSidebarToolsWidth }}
        ref={menuRef}
      >
        <Toolbar>
          <Grid container direction='row' justify='center' alignItems='center' spacing={3}>
            <Grid item xs={2}>
              <InputLabel shrink>{intl.formatMessage({ id: '3d.model' })}</InputLabel>
              <Select value={geoModelId} onChange={(e: any) => setGeoModelId(e.target.value)}>
                <MenuItem value='702'>{intl.formatMessage({ id: '3d.value.model.fohm' })}</MenuItem>
              </Select>
            </Grid>
            <Grid item xs={2}>
              <InputLabel shrink>{intl.formatMessage({ id: '3d.label.heightscale' })}</InputLabel>
              <Slider
                color='primary'
                onChange={(_e, val) => setHeightScale(val as number)}
                value={heightScale}
              />
            </Grid>
            <Grid item xs={1}>
              <InputLabel shrink>{intl.formatMessage({ id: '3d.label.buildings' })}</InputLabel>
              <Switch
                color='primary'
                onChange={(_e, val) => { setBuildingsEnabled(val) }}
                checked={buildingsEnabled}
              />
            </Grid>
            <Grid item xs={1}>
              <InputLabel shrink>{intl.formatMessage({ id: '3d.label.boreholes' })}</InputLabel>
              <Switch
                color='primary'
                onChange={(_e, val) => setBoreholesEnabled(val)}
                checked={boreholesEnabled}
              />
            </Grid>
            <Grid item xs={1}>
              <InputLabel shrink>{intl.formatMessage({ id: '3d.label.showmap' })}</InputLabel>
              <Switch
                color='primary'
                onChange={(_e, val) => setMapEnabled(val)}
                checked={mapEnabled}
              />
            </Grid>
            <Grid item xs={2}>
              <InputLabel shrink>{intl.formatMessage({ id: '3d.label.clippolygon' })}</InputLabel>
              <Switch
                color='primary'
                onChange={(_e, val) => setClipPolygonEnabled(val)}
                checked={clipPolygonEnabled}
              />
            </Grid>
            <Grid item xs={2}>
              {!clipPolygonEnabled && (
                <>
                  <InputLabel shrink>{intl.formatMessage({ id: '3d.label.clipaxis' })}</InputLabel>
                  <Select value={clipAxis} onChange={(e: any, _val) => { setClipAxis(e.target.value) }}>
                    <MenuItem value='0'>{intl.formatMessage({ id: '3d.value.clipaxis.x' })}</MenuItem>
                    <MenuItem value='1'>{intl.formatMessage({ id: '3d.value.clipaxis.y' })}</MenuItem>
                    <MenuItem value='2'>{intl.formatMessage({ id: '3d.value.clipaxis.none' })}</MenuItem>
                  </Select>
                </>
              )}
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </div>
  )
}
